import { ReactNode } from 'react';
import { useAuth } from '../hooks/useAuth';
import { LoginModal } from './LoginModal';

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const { isAuthenticated, isLoading, error, login } = useAuth();

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '1.2rem',
        color: '#666'
      }}>
        Ładowanie...
      </div>
    );
  }

  // Show login modal if not authenticated
  if (!isAuthenticated) {
    return (
      <LoginModal
        isOpen={true}
        onLogin={login}
        error={error || undefined}
      />
    );
  }

  // Show the app content if authenticated
  return <>{children}</>;
}; 